import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { FaUserAlt } from "react-icons/fa";

const Personalinformation = ({ data }) => {
  const [user, setUser] = useState(data);
  const [isEditing] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  return (
    <div className={styles.LealtadinformacionPersonal} id="personal">
      <h2 className={styles.LealtadsectionTitle}>Información Personal</h2>

      {!user ? (
        <NotReportViewData title="Información Personal" Icon={FaUserAlt} />
      ) : (
        <>
          <div className={styles.Lealtadnad}>
            <label className={styles.LealtadinputLabel}>
              Nombre:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="nombre"
                value={user.name || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Apellido:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="apellido"
                value={user.lastName || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Tipo de documento:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="tipo_documento"
                value={user.documentType || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.Lealtadnad}>
            <label className={styles.LealtadinputLabel}>
              Dni:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="cuil"
                value={user.dni || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Nacionalidad:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="nacionality"
                value={user.nacionality || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Estado civil:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="civilStatus"
                value={user.civilStatus || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.Lealtadnad}>
            <label className={styles.LealtadinputLabel}>
              CUIL:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="cuil"
                value={user.cuil || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Fecha de nacimiento:
              <input
                className={styles.LealtadinputField}
                type="date"
                name="fecha_nacimiento"
                value={user.dateOfBirth || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Lugar de nacimiento:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="lugar_nacimiento"
                value={user.placeOfBirth || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.Lealtadnad}>
            <label className={styles.LealtadinputLabel}>
              Teléfono:
              <input
                className={styles.LealtadinputField}
                type="tel"
                name="telefono"
                value={user.phone || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Correo electrónico:
              <input
                className={styles.LealtadinputField}
                type="email"
                name="correo_electronico"
                value={user.email || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Nivel socioeconómico:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="SocioEconomicLevel"
                value={user.SocioEconomicLevel || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.Lealtadnad}>
            <label className={styles.LealtadinputLabel}>
              Calle:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="street"
                value={user.street || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Numero:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="numberStreet"
                value={user.numberStreet || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Codigo postal:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="postalCode"
                value={user.postalCode || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.Lealtadnad}>
            <label className={styles.LealtadinputLabel}>
              Departamento:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="apartment"
                value={user.apartment || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Piso:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="floor"
                value={user.floor || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
            <label className={styles.LealtadinputLabel}>
              Localidad:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="location"
                value={user.location || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
          <div className={styles.Lealtadnad}>
            <label className={styles.LealtadinputLabel}>
              Provincia:
              <input
                className={styles.LealtadinputField}
                type="text"
                name="province"
                value={user.province || ""}
                onChange={handleInputChange}
                readOnly={!isEditing}
              />
            </label>
          </div>
        </>
      )}
    </div>
  );
};

export default Personalinformation;
